
import HTTP from "./Http";
import { methods } from "./Methods";
//  const BASE_URL =  import.meta.env.VITE_API_DEV_URL;

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
 

  const api =`${BASE_URL}api/v1/administration/`
 
  // const api = "http://192.168.1.44:9000/api/v1/administration/"
// REACT_API_CONTEXT_URL=https://bgi.sortstring.com/api/v1/administration/
 
// export const Postdata = async (url, data) => {
//   const fullUrl = api + url;
//   return await HTTP.Request(methods.POST, fullUrl, data);
// };

export const Postdata = async (url, data) => {
  const fullUrl = api + url;
  return await HTTP.Request(methods.POST, fullUrl, data, {
    requireAuth: true // 🚫 no token
  });
};

export const GetData = async (url) => {
  const fullUrl = api + url;
  return await HTTP.Request(methods.GET, fullUrl);
};



